export const AUTOCOMPLETION_ITEMS_DEFAULT_LIMIT = 5;
export const AUTOCOMPLETION_DEFAULT_DEBOUNCE_TIME_MS = 250;
export const AUTOCOMPLETION_CONSUMER =
  'loggedout.web.loggedout_startpage.jobs-search';

export const FILTERS_SETTINGS = {
  remote: {
    message: {
      id: 'WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_REMOTE',
      defaultMessage: 'Work from home',
    },
    query: 'remote=1',
  },
  partTime: {
    message: {
      id: 'WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_PART_TIME',
      defaultMessage: 'Part-time',
    },
    query: 'employmentType=PART_TIME.58889d',
  },
  flexible: {
    message: {
      id: 'WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_FLEXIBILITY',
      defaultMessage: 'Flexitime',
    },
    query: 'benefit=1.795d28',
  },
};

export const EXTENDED_FILTERS_SETTINGS = {
  ...FILTERS_SETTINGS,
  dogsFriendly: {
    message: {
      id: 'WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_DOGS_FRIENDLY',
      defaultMessage: 'Dogs welcome',
    },
    query: 'benefit=19.ac91c2',
  },
};
